import makeService from './api';

export default makeService('printing_surface_sizes');
